import { createApi } from '@reduxjs/toolkit/query/react';
import {
  TCreateWithdrawalRequest,
  TCreateWithdrawalResponse,
  type TCreateOrderRequest,
  type TCreateOrderResponse,
  type TGetOrderResponse,
  type TGetSelfResponse
} from '../types/MerchantTypes';
import { baseQuery, getBaseQueryWithReauth } from '../baseQueryAuth';

export const MerchantApi = createApi({
  reducerPath: 'MerchantApi',
  tagTypes: ['Merchant'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({

    getSelf: build.query<TGetSelfResponse, void>({
      query: () => ({
        url: '/merchant/get_self/',
        method: 'GET',
      }),
      providesTags: [{ type: 'Merchant', id: 'SELF' }],
      transformErrorResponse: (response: any) => response,
    }),

    getMerchantOrder: build.query<TGetOrderResponse, string>({
      query: (orderId: string) => ({
        url: `/merchant/check_order/${orderId}/`,
        method: 'GET',
        headers: {},
      }),
    }),
    createOrder: build.mutation<TCreateOrderResponse, TCreateOrderRequest>({
      query: (body) => ({
        url: '/merchant/create_order/?type=api',
        method: 'POST',
        body,
      }),
    }),
    cancelOrder: build.mutation<TGetOrderResponse, string>({
      query: (orderId) => ({
        url: `/merchant/cancel_order/${orderId}/`,
        method: 'GET',
      }),
    }),
    createWithdrawal: build.mutation<TCreateWithdrawalResponse, TCreateWithdrawalRequest>({
      query: (body) => ({
        url: '/merchant/create_withdrawal/?type=api',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetSelfQuery,
  useGetMerchantOrderQuery,
  useCreateOrderMutation,
  useCancelOrderMutation,
  useCreateWithdrawalMutation,
} = MerchantApi;
